import axiosInstance from "./Api";

export default {
  async getCourses(payload) {
    return await axiosInstance().get(`/common/course/all`, { params: payload });
  },

  async universityDetailsWithCourses(payload) {
    const { university_id } = payload;

    return await axiosInstance().get(
      `/common/university-details/${university_id}`
    );
  },

  async getChatConnections() {
    return await axiosInstance().get(`/common/chats/connections`);
  },

  async getMessage(payload) {
    const { receiver_id } = payload;

    return await axiosInstance().get(`/common/chats/message/${receiver_id}`);
  },

  async sendMessage(payload) {
    const { receiver_id, message } = payload;
    console.log(payload);
    return await axiosInstance().post(`/common/chats/message/${receiver_id}`, {
      message,
    });
  },

  async getUserProfile() {
    return await axiosInstance().get(`/common/user-profile`);
  },

  async changePassword(payload) {
    return await axiosInstance().post(`/common/change-password`, payload);
  },

  async getAllDocumentTypes() {
    return await axiosInstance().get(`/common/document-types`);
  },

  async getAllStudentDocumentTypes() {
    return await axiosInstance().get(`/common/student-document-types`);
  },

  async getAllUniversities(payload) {
    return await axiosInstance().get(`/common/university`, { params: payload });
  },

  async getAllVisaDocumentTypes() {
    return await axiosInstance().get(`/common/visa-document-types`);
  },

  async getAllStudentVisaDocumentTypes() {
    return await axiosInstance().get(`/common/student-visa-document-types`);
  },

  async getAllApplicationStatuses() {
    return await axiosInstance().get(`/common/application-statuses`);
  },

  async getAllUsers(payload) {
    return await axiosInstance().get(`/common/all-users-and-types`, {
      params: payload,
    });
  },

  async makeAnnouncement(payload) {
    return await axiosInstance().post(`/common/announcement`, payload);
  },

  async getAllAnnouncement(payload) {
    return await axiosInstance().get(`/common/announcement`, {
      params: payload,
    });
  },

  async getHomeData(payload) {
    return axiosInstance().get(`/common/home-data`, { params: payload });
  },

  async getAssignedStudents(payload) {
    return await axiosInstance().get(`/common/assigned-student`, {
      params: payload,
    });
  },

  async getAssignedStaffToStudent(payload) {
    const { student_user_id } = payload;

    return await axiosInstance().get(
      `/common/student-assigned-staff/${student_user_id}`
    );
  },

  async getStudentDetails(payload) {
    const { student_user_id } = payload;

    return await axiosInstance().get(
      `/common/student-details/${student_user_id}`
    );
  },

  async getStudentApplications(payload) {
    const { student_user_id } = payload;

    return await axiosInstance().get(
      `/common/student-applications/${student_user_id}`
    );
  },

  async getApplicationChat(payload) {
    const { sa_mapper_id, student_user_id } = payload;

    return axiosInstance().get(
      `/common/student-application-chat/${student_user_id}/${sa_mapper_id}`
    );
  },

  async sendApplicationChat(payload) {
    const { student_user_id, sa_mapper_id } = payload;

    return axiosInstance().post(
      `/common/student-application-chat/${student_user_id}/${sa_mapper_id}`,
      payload
    );
  },

  async getApplicationTimeline(payload) {
    const { student_user_id, sa_mapper_id } = payload;

    return axiosInstance().get(
      `/common/student-application-timeline/${student_user_id}/${sa_mapper_id}`,
      payload
    );
  },

  async getStudentDocuments(payload) {
    const { student_user_id } = payload;

    return await axiosInstance().get(
      `/common/student-documents/${student_user_id}`
    );
  },

  async getStudentVisaDocuments(payload) {
    const { student_user_id } = payload;

    return await axiosInstance().get(
      `/common/student-visa-documents/${student_user_id}`
    );
  },

  async getStudentRequiredDocs(payload) {
    const { student_user_id, course_level_id } = payload;

    return await axiosInstance().get(
      `/common/student-required-docs/${student_user_id}/${course_level_id}`
    );
  },

  async getStudentServicesAvailed(payload) {
    const { student_user_id } = payload;

    return await axiosInstance().get(
      `/common/student-services-availed/${student_user_id}`
    );
  },

  async getDocUploadedForStudent(payload) {
    const { student_user_id } = payload;

    return await axiosInstance().get(
      `/common/uploaded-doc-for-student/${student_user_id}`
    );
  },

  async removeDocForStudent(payload) {
    const { student_user_id, map_id } = payload;

    return await axiosInstance().post(
      `/common/remove-doc-for-student/${student_user_id}/${map_id}`
    );
  },

  async getVisaDocUploadedForStudent(payload) {
    const { student_user_id } = payload;

    return await axiosInstance().get(
      `/common/uploaded-visa-doc-for-student/${student_user_id}`
    );
  },

  async removeVisaDocForStudent(payload) {
    const { student_user_id, map_id } = payload;

    return await axiosInstance().post(
      `/common/remove-visa-doc-for-student/${student_user_id}/${map_id}`
    );
  },

  async reccomendCourseToStudents(payload) {
    const { course_id, student_user_ids } = payload;

    return await axiosInstance().post(
      `/common/recommend-course-students/${course_id}`,
      { student_user_ids }
    );
  },

  async getApplications(payload) {
    return await axiosInstance().get(`/common/applications`, {
      params: payload,
    });
  },

  async removeRecommendation(payload) {
    const { student_user_id, course_id } = payload;

    return await axiosInstance().post(
      `/common/remove-recommendation/${student_user_id}/${course_id}`
    );
  },

  async getNotifications(payload) {
    return await axiosInstance().get(`/common/notifications`, {
      params: payload,
    });
  },

  async setAllNotificationsAsRead() {
    return await axiosInstance().get(`/common/notifications/set-read`);
  },

  async setAllChatMessagesAsRead(payload) {
    const { from_user_id } = payload;

    return await axiosInstance().post(
      `/common/chats/message/set-read/${from_user_id}`
    );
  },

  // async getNewNotificationsAndMessages() {
  //   return await axiosInstance().get(`/common/new-notifications-messages`);
  // },

  async getFranchiseTrainings(payload) {
    return await axiosInstance().get(`/common/franchise-trainings`, {
      params: payload,
    });
  },

  async getFranchiseTraining(payload) {
    return await axiosInstance().get(
      `/common/franchise-training/${payload.ft_id}`,
      { params: payload }
    );
  },

  async setQuestionResponse(payload) {
    return await axiosInstance().post(`/common/question-response`, payload);
  },

  async getSampleDocuments() {
    let response = await axiosInstance().get(`/common/document/sample`);

    return response;
  },

  async getSingleUniversityExtraInfo(payload) {
    return await axiosInstance().get(
      `/common/university-info/${payload.university_id}`
    );
  },

  async getSingleUniversityUSP(payload) {
    return await axiosInstance().get(
      `/common/university-usp/${payload.university_id}`
    );
  },

  async getAllUniversityUSP(payload) {
    return await axiosInstance().get(`/common/university-usp`, {
      params: payload,
    });
  },

  async getSingleUniversitySUR(payload) {
    return await axiosInstance().get(
      `/common/university-sur/${payload.university_id}`
    );
  },

  async getAllTasks(payload) {
    return await axiosInstance().get(`/common/tasks`, { params: payload });
  },

  async getAllAssignedTasks(payload) {
    return await axiosInstance().get(`/common/tasks-assigned`, {
      params: payload,
    });
  },

  async getSingleTask(payload) {
    return await axiosInstance().get(`/common/tasks/${payload.user_id}`);
  },

  async deleteTask(payload) {
    return await axiosInstance().get(`/common/tasks/${payload.user_id}`);
  },

  async saveTask(payload) {
    return await axiosInstance().post(`/common/tasks`, payload);
  },

  async getTaskUsers() {
    return await axiosInstance().get(`/common/tasks-users`);
  },

  async getTaskStudents(payload) {
    return await axiosInstance().get(`/common/tasks-students`, {
      params: payload,
    });
  },

  async getTaskStudents(payload) {
    return await axiosInstance().get(`/common/tasks-students`, {
      params: payload,
    });
  },

  async makeStripePayment(payload) {
    const { plan_id, student_user_id, url } = payload;

    let response = await axiosInstance().get(
      `/common/stripe-payment/make/${student_user_id}/${plan_id}`,
      {
        params: { url },
      }
    );

    return response;
  },

  async verifyTransaction(payload) {
    const { transaction_id } = payload;
    let response = await axiosInstance().get(
      `/common/stripe-payment/verify/${transaction_id}`
    );
    return response;
  },

  async getTaskChat(payload) {
    const { task_id } = payload;
    return axiosInstance().get(`/common/task-chat/${task_id}`);
  },

  async sendTaskChat(payload) {
    const { task_id } = payload;

    return axiosInstance().post(`/common/task-chat/${task_id}`, payload);
  },

  async saveChecklistlistInfo(payload) {
    const { student_user_id } = payload;
    return await axiosInstance().post(
      `/common/save-application-checklist-info/${student_user_id}`,
      payload
    );
  },
};
